import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import ErrorBoundary from '../../pages/errors/ErrorBoundary';
import DashboardDarkModeToggle from '../UI/DashboardDarkModeToggle';
import { useUIStore } from '../../store/uiStore';

const STORAGE_KEY = 'fex-dashboard-dark';

const DashboardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { initDarkMode } = useUIStore();
  const [, setDashboardDark] = useState(false);

  useEffect(() => {
    const localUser = localStorage.getItem('user');
    const user = localUser ? JSON.parse(localUser) : null;
    const isUserDashboardRoute = location.pathname.startsWith('/dashboard/user');
    const isProfileRoute = location.pathname.includes('/dashboard/user/profile');
    const role = localStorage.getItem('role');

    // Only force profile completion for standard users
    if (
      isUserDashboardRoute &&
      role === 'user' &&
      user && (!user.address || user.address.trim() === '') &&
      !isProfileRoute
    ) {
      navigate('/dashboard/user/profile');
    }

    // Admin and Agent route gating is handled by dedicated route guards
  }, [navigate, location]);

  // Initialize dashboard dark mode: only override if dashboard key exists
  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) {
      // No dashboard-specific preference; respect global
      initDarkMode();
      const globalIsDark = document.documentElement.classList.contains('dark');
      setDashboardDark(globalIsDark);
    } else {
      const pref = raw === 'true';
      setDashboardDark(pref);
      if (pref) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
    return () => {
      // Restore global preference when leaving dashboard
      initDarkMode();
    };
  }, [initDarkMode]);

  return (
    <div className="min-h-screen bg-white dark:bg-dark-bg dark:text-dark-text">
      <div className="container mx-auto px-4 py-6 relative">
        {/* Dashboard dark mode toggle - fixed top/right within dashboard layout */}
        <div className="absolute right-4 top-4 z-50">
          <DashboardDarkModeToggle size="sm" className="shadow" />
        </div>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default DashboardLayout;
